import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { datetimeToDate } from '../../../utils/dateFormat';
import { CaDashboardTable } from '../dashboardTableCorrectiveAction/CaDashobardTable';
import { useGetCaManagerTlSearchQuery } from '../managerTlViewSearch/CaMangerTLView.slice';
import { caDetails } from '../type';
import './CaDashboard.scss';

interface CaDashboardProps {
    setActiveIndex: (e: number) => void;
    setSelectedEmployee: (e: caDetails | undefined) => void;
    setVia: (e: string) => void;
    fromPage: string;
    pendingApprovalsData?: any;
}

export const CaDashboard = (props: CaDashboardProps) => {
    const toast = useRef<Toast | null>(null);
    const authorOptions = [
        {
            value: 'Created for Current Team',
            id: 'currentTeam',
        },
        {
            value: 'Created by Me',
            id: 'byMe',
        },
    ];
    const [author, setAuthor] = useState<string>(authorOptions[0].id);
    const [isCurrentTeam, setIsCurrentTeam] = useState<boolean>(true);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [caMangerTlData, setCaMangerTlData] = useState<any>([]);

    const [creationEndDate, setCreationEndDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());

    const setCreationDate = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 30);
        return currentDate;
    };
    const [creationStartDate, setCreationStartDate] = useState<Date>(() => setCreationDate());

    const { data: caMangerTlDataSlice } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: loggedEmpNum,
            isCurrentTeam: props.fromPage === 'CorrectiveActionsAssignment' ? isCurrentTeam : undefined,
            isApprovals: false,
            CreationStartDate: datetimeToDate(creationStartDate),
            CreationEndDate: endDate ? datetimeToDate(endDate) : '',
        },
        { skip: !loggedEmpNum || !creationStartDate||props.fromPage === 'PendingApprovals' }
    );

    useEffect(() => {
        if (caMangerTlDataSlice?.data?.length > 0) {
            setCaMangerTlData(caMangerTlDataSlice.data);
        } else {
            setCaMangerTlData([]);
        }
    }, [caMangerTlDataSlice]);

    const changeCreationStartDate = (e: any) => {
        setCreationStartDate(e.value);
        window.localStorage.setItem('CaDashboardCreationStartDate', e.value);
    };

    const changecreationEndDate = (e: any) => {
        if (e.value) {
            const date = new Date(e.value);
            date.setDate(date.getDate());
            setCreationEndDate(e.value);
            setEndDate(date);

            window.localStorage.setItem('CaDashboardCreationEndDate', e.value);
        } else {
            setCreationEndDate(null);
            setEndDate(null);
        }
    };

    useEffect(() => {
        const creationStartDate = window.localStorage.getItem('CaDashboardCreationStartDate');
        if (creationStartDate) {
            setCreationStartDate(new Date(creationStartDate));
        }

        const creationEndDate = window.localStorage.getItem('CaDashboardCreationEndDate');
        if (creationEndDate) {
            setCreationEndDate(new Date(creationEndDate));
        }
     }, []);


    return (
        <>
            <Toast ref={toast} position="top-center" />
            {props.fromPage === 'CorrectiveActionsAssignment' && (
                <div className="row mt-4">
                    <div className="col-md-3">
                        <h6
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                            }}
                        >
                            Author
                        </h6>
                        <Dropdown
                            name="id"
                            value={author}
                            options={authorOptions}
                            onChange={(event) => {
                                setAuthor(event.target.value);
                                if (event.target.value === 'currentTeam') {
                                    setIsCurrentTeam(true);
                                } else {
                                    setIsCurrentTeam(false);
                                }
                            }}
                            optionValue={'id'}
                            optionLabel={'value'}
                            placeholder="Select Author"
                            className="custom-dropdown w-300"
                        />
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="recipientName">Creation Start Date</label>
                                <Calendar
                                    id="icon"
                                    value={creationStartDate}
                                    dateFormat="dd-M-yy"
                                    onChange={changeCreationStartDate}
                                    showIcon
                                    className="custom-calendar"
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="recipientName">Creation End Date</label>
                                <Calendar
                                    id="icon"
                                    value={creationEndDate}
                                    dateFormat="dd-M-yy"
                                    onChange={changecreationEndDate}
                                    showButtonBar
                                    showIcon
                                    className="custom-calendar"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <CaDashboardTable
                setActiveIndex={props.setActiveIndex}
                setVia={props.setVia}
                setSelectedEmployee={props.setSelectedEmployee}
                caMangerTlData={props.fromPage==='PendingApprovals'?props.pendingApprovalsData:caMangerTlData}
                fromPage={props.fromPage}
                // isCurrentTeam={isCurrentTeam}
            />
        </>
    );
};
